import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgxMaskModule } from 'ngx-mask';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { ThemeModule } from './theme/theme.module';
import { RoutesModule } from './routes/routes.module';
import { AppComponent } from './app.component';
// import { DataTablesModule } from 'angular-datatables';
import { DefaultInterceptor } from '@core';
import { StartupService } from '@core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {AuthService} from './auth-guard/auth.service';
import {AuthGuard} from './auth-guard/auth.guard';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { AgmCoreModule } from '@agm/core';
import { DatePipe } from '@angular/common';
// import { BnNgIdleService } from 'bn-ng-idle';

export function StartupServiceFactory(startupService: StartupService) {
  return () => startupService.load();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    CoreModule,
    SharedModule,
    ThemeModule,
    RoutesModule,
    BrowserAnimationsModule,
   
    // DataTablesModule,
    NgxMaskModule.forRoot(),
    MatGoogleMapsAutocompleteModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCBCXYqkcj0C6LhMwBvhvOE6ciW24rP5sQ',
      libraries: ['places']
    }),
    
  ],
  providers: [AuthService,AuthGuard,DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: DefaultInterceptor, multi: true },
    StartupService,
    {
      provide: APP_INITIALIZER,
      useFactory: StartupServiceFactory,
      deps: [StartupService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
